/**
 * @file   src\actions\userprofile.js
 * @brief  This file is responsible for redux actions related to userdetails
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getGitchaAvailableCities,
  getGitchaAvailableStates,
} from "../services/commonServices";

export const fetchGitchaAvailableCities = createAsyncThunk(
    "locations/fetchGitchaAvailableCities",
    async (requestPayload) => {
      let resultObj = {}
      return await getGitchaAvailableCities(requestPayload).then((response)=>{
        const state = requestPayload?.state
        resultObj =  {state : state , cities : response.result};
        return resultObj;
      });
    }
  );

// Fetch all available cities across all states for search filtering
export const fetchAllAvailableCities = createAsyncThunk(
  "locations/fetchAllAvailableCities",
  async () => {
    const statesResponse = await getGitchaAvailableStates();
    const states = statesResponse?.result || [];
    const allCities = [];
    for (const st of states) {
      const citiesResponse = await getGitchaAvailableCities({
        state: st.StateCode,
      });
      const cities = citiesResponse?.result || [];
      cities.forEach((c) => {
        allCities.push({ City: c.City, StateCode: st.StateCode });
      });
    }
    return allCities;
  }
);
